__turbopack_context__.v({
  "className": "caveat_eb5b1c23-module__EfcgTW__className",
  "variable": "caveat_eb5b1c23-module__EfcgTW__variable",
});
